var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnRate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3115_11504)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5754 5.79297L10.6568 5.04164L8.4521 0.345642C8.28743 -0.00502507 7.7121 -0.00502507 7.54743 0.345642L5.34343 5.04164L0.424766 5.79297C0.0207661 5.85497 -0.140567 6.34631 0.142766 6.63631L3.7161 10.299L2.87143 15.477C2.8041 15.8883 3.24343 16.197 3.60677 15.995L8.0001 13.567L12.3934 15.9956C12.7534 16.1956 13.1968 15.893 13.1288 15.4776L12.2841 10.2996L15.8574 6.63698C16.1408 6.34631 15.9788 5.85497 15.5754 5.79297Z",
    fill: "#FFC107"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3115_11504"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.0703125)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnRate);
export default __webpack_public_path__ + "static/media/icn_rate.16c0175f554e6a40f36c3882c8607fe4.svg";
export { ForwardRef as ReactComponent };